// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","loadingFlair":"Loading_loadingFlair__m4hLz"};